import {dbGet} from 'utils/ajaxUtils';

export const approveSubmission = id => dbGet(`ugc/submission/${id}/approve`, {});

export const unapproveSubmission = id => dbGet(`ugc/submission/${id}/unapprove`, {});

export const deleteSubmission = id => dbGet(`ugc/submission/${id}/delete`, {});

export const favoriteSubmission = id => dbGet(`ugc/submission/${id}/favorite`, {});

export const unfavoriteSubmission = id => dbGet(`ugc/submission/${id}/unfavorite`, {});



// WEBPACK FOOTER //
// ./public/api/ugc-legacy.js